import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login";
import Mainpage from "./pages/Mainpage";
import Subpage from "./pages/Subpage";
import { UserProvider } from "./components/Auth/userContext";
import PrivateRoute from "./components/Auth/PrivateRoute";

function App() {
  return (
    <div className="App">
      <UserProvider>
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/accessibility_epub/dashboard" replace />}
          />
          <Route path={"/:state"} element={<Login />}></Route>
          <Route
            path="/accessibility_epub"
            element={
              <PrivateRoute>
                <Mainpage />
              </PrivateRoute>
            }
          >
            <Route path=":fileId?/:category?/:pages" element={<Subpage />} />
          </Route>
        </Routes>
      </UserProvider>
    </div>
  );
}

export default App;
